let accessToken = null;
let refreshToken = null;
let onLogoutCallback = null;

console.log("apiClient.js module initialized.");

// Tente de charger les jetons depuis le localStorage au démarrage
try {
    accessToken = localStorage.getItem('accessToken');
    refreshToken = localStorage.getItem('refreshToken');
    console.log("apiClient.js: Initial load from localStorage. accessToken:", accessToken ? "present" : "null", "refreshToken:", refreshToken ? "present" : "null");
} catch (e) {
    console.error("Erreur lors du chargement des jetons depuis localStorage:", e);
}

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

export const setTokens = (newAccessToken, newRefreshToken) => {
    accessToken = newAccessToken;
    refreshToken = newRefreshToken;
    
    // Persister les jetons dans localStorage pour qu'ils survivent aux rechargements de page
    try {
        localStorage.setItem('accessToken', newAccessToken);
        localStorage.setItem('refreshToken', newRefreshToken);
        console.log("setTokens called. accessToken stored:", newAccessToken ? "yes" : "no", "refreshToken stored:", newRefreshToken ? "yes" : "no");
    } catch (e) {
        console.error("Erreur lors de la sauvegarde des jetons dans localStorage:", e);
    }
    
};

export const setLogoutCallback = (callback) => {
    onLogoutCallback = callback;
};

export const apiClient = async (url, options = {}) => {
    const isFormData = options.body instanceof FormData;
    const headers = {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        ...options.headers,
    };

    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
    }

    try {
        let response = await fetch(url, { ...options, headers });

        if (response.status === 401 && refreshToken) {
            if (isRefreshing) {
                return new Promise(function(resolve, reject) {
                    failedQueue.push({ resolve, reject });
                }).then(token => {
                    headers['Authorization'] = `Bearer ${token}`;
                    return fetch(url, { ...options, headers });
                }).catch(err => {
                    return Promise.reject(err);
                });
            }

            isRefreshing = true;

            const refreshResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/refresh_token.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refresh_token: refreshToken })
            });
            const refreshData = await refreshResponse.json();

            if (refreshData.success) {
                setTokens(refreshData.token, refreshData.refresh_token);
                isRefreshing = false;
                processQueue(null, refreshData.token);
                headers['Authorization'] = `Bearer ${refreshData.token}`;
                response = await fetch(url, { ...options, headers }); // Re-tenter la requête originale
            } else {
                isRefreshing = false;
                processQueue(new Error(refreshData.message || "Session expirée."), null);
                if (onLogoutCallback) onLogoutCallback();
                return Promise.reject(new Error(refreshData.message || "Session expirée."));
            }
        }

        return response;
    } catch (error) {
        console.error("API Client Error:", error);
        return Promise.reject(error);
    }
};

// Fonction utilitaire pour effacer les jetons lors de la déconnexion
export const clearTokens = async () => {
    accessToken = null;
    refreshToken = null;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    // Dans une application réelle, vous appelleriez également un endpoint backend ici
    // pour invalider le jeton de rafraîchissement côté serveur.
    // Exemple :
    // await fetch(`${process.env.REACT_APP_API_BASE_URL}/logout.php`, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ refreshToken: refreshToken })
    // });
};